export const environment = {
  production: false,
  urlApi: 'http://localhost:8080/api/v1',
  idCanal: 0,
};